import { type com } from 'efd-cdb_backend-interfaces-ts'

export type CdbSmallMaterialDTO =
  com.mocira.inside.cdb.client.dto.CdbSmallMaterialDTO
